import { defineComponent as r, openBlock as a, createBlock as l, unref as p, mergeProps as c, withCtx as m, createElementVNode as o } from "vue";
import { RevIcon as d } from "@ds/components/Icon";
const u = /* @__PURE__ */ r({
  name: "IconInfo",
  __name: "IconInfo",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(n) {
    const t = n;
    return (f, e) => (a(), l(p(d), c(t, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        o("path", { d: "M12.75 7.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-3 3a.75.75 0 0 1 .75-.75h1A1.25 1.25 0 0 1 12.75 11v4.75h.75a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1 0-1.5h.75v-4.5H10.5a.75.75 0 0 1-.75-.75" }, null, -1),
        o("path", {
          "fill-rule": "evenodd",
          d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25M3.75 12a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
